<div class="container">
    <div class="container-title">
        <span style="width: 97%;">{{camName}}</span>
        <span class="close-modal" (click)="closeModal()">
            <i nz-icon nzType="close" nzTheme="outline"></i>
        </span>
    </div>
    <div #playerContainer class="player" (mouseenter)="showControls()" (mouseleave)="hideControls()">
        <div class="freeze-overlay" *ngIf="freezeStreaming">
            <span class="overlay-question">Você ainda está assistindo?</span>
            <span class="overlay-button" (click)="this.loadPlayer(camera)">
                <span nz-icon nzType="caret-right" style="margin-right: 4px;" nzTheme="outline"></span>Clique para continuar
            </span>
        </div>
        @if(noRecording) {
          <div class="freeze-overlay">
            <span class="overlay-question">Sem gravação disponível</span>
            <span class="overlay-button" (click)="backToLive(camera)">
                <span nz-icon nzType="caret-right" style="margin-right: 4px;" nzTheme="outline"></span>Clique para voltar ao vivo
            </span>
        </div>
        }
        <div class="camera-status" [ngClass]="{
            'camera_status_true': camera.status === true,
            'camera_status_false': camera.status === false}">
            <i *ngIf="!camera.status" nz-icon nzType="loading" nzTheme="outline" style="color: #FFFFFF;"></i>
        </div>
        <video #video autoplay="true" class="videoplayer"></video>
        <div [hidden]="!visibility" class="download-popover" id="tooltip">
          <div class="flex justify-between">
            <span class="content-title">Selecione o intervalo para download</span>
            <span class="close-modal" (click)="closePopover()">
              <i nz-icon nzType="close" nzTheme="outline"></i>
            </span>
          </div>
          <div class="flex items-center">
            <div>
              <mat-form-field>
                  <input style="font-weight:400" placeholder="Selecionar data" matInput [(ngModel)]="selectedDateCalendar"
                  (dateChange)="selectDate($event)" [matDatepicker]="picker2" [matDatepickerFilter]="filterDateInterval">
                <mat-datepicker-toggle matIconSuffix [for]="picker2" style="position: absolute; right: 10px; bottom: -25px;"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </div>
            <div style="margin-bottom: 8px; margin-left: 24px;">
              <nz-input-group nzCompact>
                  <input type="text" nz-input #initialTime class="time-begin input-date-style"
                  mask="Hh:m0" placeholder="Selecionar hora" [(ngModel)]="beginTime" disabled name="beginTime" [showMaskTyped]="false" [dropSpecialCharacters]="false" />
                  <input
                      type="text"
                      disabled
                      nz-input
                      placeholder="-"
                      style="width: 30px; height: 44px; border-left: 0px; border-right: 0px; pointer-events: none; background-color: rgb(255, 255, 255);"
                      class="input-date-style input-date-style-mid"
                  />
                  <input type="text" nz-input  #finalTime class="time-end input-date-style" disabled
                  mask="Hh:m0" placeholder="Selecionar hora" [(ngModel)]="endTime"  name="endTime" [showMaskTyped]="false" [dropSpecialCharacters]="false" />
                  <div class="time-range-picker">
                      <app-time-range-picker (changeTime)="getTime($event)"
                          [time]="[beginTime, endTime]"
                          [calendarSelect]="false"
                          [timeline]="true">
                      </app-time-range-picker>
                  </div>
              </nz-input-group>
            </div>
          </div> 
          <div class="flex justify-end">
            <button class="download-button" [disabled]="isDownloading" (click)="downloadVideo()">
              <span *ngIf="!isDownloading" style="margin-right: 10px;" nz-icon nzType="download" nzTheme="outline"></span>
              Baixar
              <span *ngIf="isDownloading" style="margin-right: 10px;" nz-icon nzType="loading" nzTheme="outline"></span>
            </button>
          </div>
        </div>
        <div class="controls-container" [ngClass]="{ 'visible': true }">
        <div class="arrows flex justify-between items-center">
          <span (click)="previousDate()" class="icon-controls" nz-icon nzType="left" nzTheme="outline" nz-tooltip
          nzTooltipTitle="Anterior"
          nzTooltipOverlayClassName="camera_playlist_processing integrated"></span>
          @if(hasNextDate()) {<span (click)="nextDate()" class="icon-controls" nz-icon nzType="right" nzTheme="outline" nz-tooltip
          nzTooltipTitle="Próximo"
          nzTooltipOverlayClassName="camera_playlist_processing integrated"></span>}
        </div>

        <app-video-timeline
          [ngStyle]="{zIndex: noRecording ? 0 : 9999999999}"
          [segmentsRecord]="videoTimeline$ | async"
          [isPaused]="getVideoIsPaused()"
          [totalMinutes]="totalMinutes"
          [isLive]="isLive"
          [currentTimelineDate]="currentDate"
          [playbackRate]="speed"
          (timeClicked)="getRecordingByTimeClicked($event)"
          (timeChanged)="updateProgressTime($event)"
          ></app-video-timeline>

        <div class="bottom flex justify-between items-center mt-2" id="video-controls">
          <div class="controls-left flex items-center gap-4">
            <button data-title="Play (k)" id="play" class="button_player">
              <img src="./../../../assets/img/Icons/play_circle.svg" alt="" [hidden]="!(video.paused || video.ended)" />
              <span style="font-size: 24px; color: #F3F9FF" nz-icon nzType="pause" nzTheme="outline" [hidden]="video.paused || video.ended"></span>
          </button>
            <div class="items-center gap-2 hidden">
              <button (click)="replayFn()" data-title="Skip (s)" id="replay" class="button_player">
                <img style="width: 80%;" src="./../../../assets/img/Icons/replay_10.svg" alt="">
              </button>

              <button (click)="forwardFn()" data-title="Skip (s)" id="forward" class="button_player">
                  <img style="width: 80%;" src="./../../../assets/img/Icons/forward_10.svg" alt="">
              </button>
            </div>
            @if(!isLive) {
              <div class="flex flex-row">
                <div>
                  <span class="progress-time">{{progressTime | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
                </div>
                <span class="info-camera" nz-icon nzType="info-circle" nz-tooltip 
            nzTooltipTitle="O horário do sistema pode apresentar divergência do da câmera"
            nzTooltipPlacement="top"></span>
              </div>
            
          }
            <div
              [ngStyle]="{
                cursor: !isLive ? 'pointer' : 'not-allowed'
              }"
              class="flex items-center gap-2 live-container"
              >
              @if(isLive) {
                <div class="live-indicator-live"></div>
                <p class="live-text">Ao vivo</p>
              } @else {
                <div class="live-indicator-back"></div>
                <p (click)="backToLive(camera)" class="live-text">Voltar para o Ao vivo</p>
              }
            </div>
          </div>
          <div class="controls-right flex items-center justify-between gap-2">
            <span (click)="openPopover()"[hidden]="true" class="icon-controls" nz-icon nzType="download" nzTheme="outline"></span>        
          <div style="
            display: flex;
            align-items: center;
            margin-bottom: 0;
            z-index: 90;
          "
        >
          <div style="background-color: rgba(108, 172, 255, 0.3); display: flex; align-items: center; margin-bottom: 0; z-index: 90;
            border-radius: 50%; height: 40px; width: 40px; justify-content: center; position: relative; margin-right: 10px;">
            <input matInput [matDatepicker]="picker1" [matDatepickerFilter]="filterDateInterval" (dateInput)="dataSelection($event)" [(ngModel)]="currentDate" [ngModelOptions]="{ standalone: true }"
            class="calendar-color" style="cursor: default; visibility: hidden; width: 1px;" readonly>
            <mat-datepicker-toggle style="margin-bottom: 0px; margin-right: 0.5rem; margin-left: 0.7rem;" matSuffix
            [for]="picker1" class="date_calender_edit" [class.selected]="selectedDate">
            </mat-datepicker-toggle>
            <mat-datepicker #picker1> </mat-datepicker>
        </div>
        
        <nz-select [(ngModel)]="currentInterval" (ngModelChange)="changeTimelineInterval($event)" style="margin-right: 12px;">
          <nz-option *ngFor="let option of optionsOfSelectTime" [nzValue]="option.value" [nzLabel]="option.label"
            [ngStyle]="{'background-color': selectedValueOfSelectTime === option.value ? '#1890ff' : 'transparent', 
                        'color': selectedValueOfSelectTime === option.value ? 'white' : 'black'}">
          </nz-option>
        </nz-select>
        @if(!isLive) {
              <nz-select
                ngModel="selected"
                nzPlaceHolder="1x"
                (ngModelChange)="changePlaySpeed($event)"
              >
                <nz-option nzLabel="1x" nzValue="1" nzLabel="1x"></nz-option>
                <nz-option nzLabel="1.5x" nzValue="1.5"></nz-option>
                <nz-option nzLabel="2x" nzValue="2"></nz-option>
                <nz-option nzLabel="3x" nzValue="3"></nz-option>
                <nz-option nzLabel="4x" nzValue="4"></nz-option>
                <nz-option nzLabel="8x" nzValue="8"></nz-option>
                <nz-option nzLabel="16x" nzValue="16"></nz-option>
              </nz-select>
              }
            <span class="icon-controls" nz-icon [nzType]="isFullscreen ? 'fullscreen-exit' : 'fullscreen'" (click)="toggleFullScreen()" nzTheme="outline"></span>
          </div>
        </div>
      </div>
    </div>
</div>
